import React from "react"
import {useStats} from "react-instantsearch"
import {useTranslation} from "react-i18next"

const Stats = (props) => {
  const {t} = useTranslation()
  const {nbHits, processingTimeMS} = useStats()

  return (<>
    {nbHits != '0' && <div className={`bb-product-info ${props.className}`}>
      <span className="bb-product-info-count"  {...{ "processingTimeMS": processingTimeMS }}>
        {nbHits} {nbHits == 1 ? t("product") : t("products")}{" "}
      </span>
    </div>}
  </>)
}
export default Stats
